import React from 'react'
import { Empty, Table, Icon } from 'antd'
import { useTranslation } from 'react-i18next'
import AdCard from './AdCard'
import RowActions from './RowActions'
import { formatDate } from '../utils/adapters'
import { getSimilarAspectRatio } from '../../../../services/display'
import AdGridHolder from '../styles/adGridStyle'

const TYPE_ICON = {
  image: 'picture',
  video: 'video-camera',
}

const AdGrid = ({
  ads = [],
  viewMode = 'grid',
  selectedIds = [],
  onToggleSelect,
  onSetSelection,
  getMenuItems,
  onPreview,
}) => {
  const { t } = useTranslation()

  if (!ads.length) {
    return (
      <AdGridHolder>
        <Empty description={t('No ads yet')} />
      </AdGridHolder>
    )
  }

  if (viewMode === 'list') {
    const columns = [
      {
        title: t('Name'),
        key: 'name',
        render: (_, ad) => (
          <div
            className="cell-thumb-name"
            onClick={() => onPreview && onPreview(ad)}
            role="button"
          >
            {ad.thumbnail ? (
              <img src={ad.thumbnail} alt={ad.name} className="row-thumb" />
            ) : (
              <span className="row-thumb placeholder">
                <Icon type={TYPE_ICON[ad.type] || 'file'} />
              </span>
            )}
            <span className="row-name">{ad.name}</span>
          </div>
        ),
      },
      {
        title: t('Aspect'),
        key: 'aspect',
        width: 150,
        render: (_, ad) =>
          ad.width && ad.height ? getSimilarAspectRatio(ad.width, ad.height, t) : '-',
      },
      {
        title: t('Creation date'),
        key: 'date',
        width: 160,
        render: (_, ad) => formatDate(ad.date),
      },
      {
        title: t('Actions'),
        key: 'actions',
        width: 90,
        align: 'center',
        render: (_, ad) => <RowActions items={getMenuItems ? getMenuItems(ad) : []} />,
      },
    ]

    const rowSelection = {
      // antd v3 mishandles frozen (seamless-immutable) arrays for selection,
      // so pass a plain mutable copy.
      selectedRowKeys: Array.from(selectedIds),
      onChange: (keys) => onSetSelection && onSetSelection(keys),
    }

    return (
      <AdGridHolder className="table-view">
        <Table
          rowKey="id"
          columns={columns}
          dataSource={Array.from(ads)}
          rowSelection={rowSelection}
          pagination={false}
          size="middle"
          title={() => t('Ads')}
        />
      </AdGridHolder>
    )
  }

  return (
    <AdGridHolder className="grid-view">
      {ads.map((ad) => (
        <AdCard
          key={ad.id}
          ad={ad}
          viewMode={viewMode}
          selected={selectedIds.includes(ad.id)}
          onToggleSelect={() => onToggleSelect && onToggleSelect(ad.id)}
          onPreview={() => onPreview && onPreview(ad)}
          menuItems={getMenuItems && getMenuItems(ad)}
        />
      ))}
    </AdGridHolder>
  )
}

export default AdGrid
